import { all, fork } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { authSaga } from '@/features/authentication/common/store/authSaga';

export function* rootSaga(): SagaIterator {
  yield all([fork(authSaga)]);
}
